import React from 'react';
import { Button } from '@material-ui/core';
import { useNavigate } from '@reach/router';
import { Redux, Slices } from 'spwa-ui-library';
import { exitAccountDeletionGA } from 'spwa-ui-library/esm/utils/helperGA';
import { FormattedMessage, useIntl } from 'react-intl';
import tickIcon from './images/DeletionComplete.svg';
import css from './index.module.scss';
import BackButton from '../../components/BackButton';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;

const AccountDeleted = ({ navList }) => {
  const isDesktop = useSelector(selectDesktop);
  const navigate = useNavigate();
  const intl = useIntl();

  const exitHandler = () => {
    exitAccountDeletionGA();
    navigate(`/${intl.locale}/home`);
  };

  return (
    <>
      <div className={css.main}>
        <div className={css.accountDeletedContainer}>
          {isDesktop && (
            <div className={css.backBtnWrap}>
              <div className={css.spacer}></div>
              <BackButton handleBack={exitHandler} type="cross" />
            </div>
          )}
          {/* <DoubleCheck /> */}
          <div className={css.imgWrapper}>
            <img src={tickIcon} alt="Tick Icon" />
          </div>
          <div className={css.heading}>
            <FormattedMessage id="account_deletion_complete" />
          </div>
          <div className={css.message}>
            <FormattedMessage id="thankyou_for_using_PizzaHut_app" />
          </div>
          <div className={css.message}>
            <FormattedMessage id="seeyou_soon_in_future" />
          </div>
          <div className={css.actionContainer}>
            <Button
              variant="contained"
              color="primary"
              className={css.exitBtn}
              onClick={exitHandler}
            >
              <FormattedMessage id="exit" />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountDeleted;
